import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import { stripHTML } from 'utils/string';
import { SUBSCRIPTION_PERPETUAL_OVERVIEW, SUBSCRIPTION, getRoute } from 'routes';
import { ClearIcon } from '../../theme/icons';
import FormField from '../../components/FormField';
import _ from 'lodash';
import { Button, Link } from '@material-ui/core';
import {
	MAXIC_DISCOUNT_PROD_TYPE,
	DISCOUNTS_CONFIG,
	DISCOUNT_TYPE,
	DISCOUNT_KEY,
	COUPON_TYPE,
	FALLBACK_COUPON,
	PACKAGES_CONFIG,
	PLAN_CATEGORIES,
	SUBSCRIPTION_PLAN
} from '../../config';

import { trackApplyCouponClicked, trackActiveOfferLinkClicked } from 'lib/Segment/customTrackers';
import { getTrackingOptions } from 'lib/Segment/helpers';

import { setSubscriptionPeriod } from 'redux/modules/app';
import { 
	sendCurrentOfferToUser,
	applyDiscountUsingCouponIdWithoutValidation,
	applyDiscountUsingCouponId,
	clearAppliedDiscount,
	setUserSuppliedPromoCode
} from 'redux/modules/discount';
import i18n from 'i18n/i18n';
import ERROR from 'errors/errorids';
import AppError from 'errors/apperror';
import Logger from 'logger/logger';


const WEBL_ACTIVE_OFFERS_URL = process.env.REACT_APP_WEBL_ACTIVE_OFFERS_URL;
const PHOTOL_ACTIVE_OFFERS_URL= process.env.REACT_APP_PHOTOL_ACTIVE_OFFERS_URL;
const DESIGNERL_ACTIVE_OFFERS_URL = process.env.REACT_APP_DESIGNERL_ACTIVE_OFFERS_URL;
const SUBSCRIPTION_ACTIVE_OFFERS_URL = process.env.REACT_APP_SUBSCRIPTION_ACTIVE_OFFERS_URL;

const log = Logger.get('promoform');
const localize = i18n.loc.localize;
const BREAKPOINT_SM_DIFFERENCE = 70;

const errors = {
	[ERROR.OFFLINE] : 'subscriptions-error-offline',
	[ERROR.INVALID_COUPON_CODE_ID] : 'subscriptions-error-invalid-coupon-code',
	[ERROR.FAILED_TO_RETRIEVE_COUPON] : 'subscriptions-error-failed-to-retrieve-coupon',
	[ERROR.COUPON_CODE_DOES_NOT_EXIST] : 'subscriptions-error-coupon-does-not-exist',
	[ERROR.API_REQUEST_LIMIT_EXCEEDED]: 'error-cb-api-rate-limit-reached'
};

const invalidReason = {
	'does-not-exist': 'subscriptions-error-coupon-does-not-exist',
	'expired': 'subscriptions-error-coupon-code-expired',
	'serial-number': 'subscriptions-error-coupon-code-is-serial-number',
	'one-time-coupon-used': 'subscriptions-error-coupon-one-time-already-used',
	'cannot-replace-existing-coupon' : 'subscriptions-error-cannot-replace-existing-coupon',
	'not-applicable-to-any-of-products': 'subscriptions-error-coupon-does-not-qualify-for-any-product',
	'not-applicable-to-this-product': 'subscriptions-error-coupon-does-not-qualify-for-this-product',
	'applicable-to-products-in-different-currency': 'subscriptions-error-applicable-to-products-in-different-currency',
	'applicable-to-products-in-different-route': 'subscriptions-error-coupon-does-not-qualify-fallback',
	'applicable-to-this-product-in-different-currency': 'subscriptions-error-applicable-to-this-product-in-different-currency'
};

const styles = theme => ({
	promoForm: {
		[theme.breakpoints.down(theme.breakpoints.values.sm + BREAKPOINT_SM_DIFFERENCE)]: {
			flexDirection: 'column'
		}
	},

	columnPromoFormInputColumn: {
		width: 188,
		[theme.breakpoints.down(theme.breakpoints.values.sm + BREAKPOINT_SM_DIFFERENCE)]: {
			width: '100%',
			marginBottom: 10
		},
		position: 'relative'
	},

	columnPromoFormInputRoot: {
	},

	columnPromoFormInput: {
		width: '100%',
		'& input': {
			'&::placeholder': {
				fontFamily: 'Open Sans, sans-serif',
				fontWeight: 'normal',
				fontStyle: 'normal',
				fontSize: '14px',
				lineHeight: '19px',
				color: theme.palette.text.primary
			}
		},

		'& [id*=helper-text]': {
			paddingLeft: 0
		}
	},

	errorHelperText: {
		color: theme.palette.colors.error,
		opacity: 1,
		fontFamily: '"Open Sans Xara", Arial, Helvetica, sans-serif',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '18px'
	},

	errorMessageLink: {
		fontSize: 'inherit',
		'&:hover': {
			color: '#2888C3'
		}		
	},

	activeOfferLink: {
		fontSize: 'inherit',
		'&:hover': {
			color: '#2888C3'
		}
	},
	activeOfferMessage: {
		display: 'block',
		marginBottom: 10
	},

	fallbackCouponMessage: {
		display: 'block',
		width: 320
	},

	fallbackCouponMessageLink: {
		margin: '0 0 0 5px',
		fontSize: 'inherit',
		'&:hover': {
			color: '#2888C3'
		}		
	},

	textInput: {
		margin: 0,

		'& input': {
			borderWidth: 1,
			borderStyle: 'solid',
			borderRadius: 5,
			borderColor: theme.palette.secondary.lighter,
			color: theme.palette.text.primary,
			padding: '7px 10px',

			'&:focus': {
				borderColor: theme.palette.primary.main
			},

			'&::placeholder': {
				fontFamily: 'Open Sans, sans-serif',
				fontWeight: 'normal',
				fontStyle: 'normal',
				fontSize: '14px',
				lineHeight: '19px',
				color: theme.palette.text.primary
			}
		},
	},

	button: {
		padding: '0 15px 1px',
		borderRadius: '21px',
		background: '#000',
		fontSize: '14px',
		lineHeight: '35px',
		fontWeight: 600,
		textTransform: 'uppercase',
		textShadow: 'none',
		'&:hover': {
			backgroundColor: theme.palette.colors.darkPurpleHover
		}
	},

	clearPromoCodeButton: {
		fontSize: '10px',
		lineHeight: '34px',
		textTransform: 'uppercase',
		position: 'absolute',
		top: 1,
		right: 1,
		width: '30px',
		height: '32px',
		borderRadius: 5,
		color: theme.palette.text.primary,
		background: '#fff',
		opacity: 1
	},

	columnPromoFormSubmitColumn: {
		paddingLeft: '10px',
		[theme.breakpoints.down(theme.breakpoints.values.sm + BREAKPOINT_SM_DIFFERENCE)]: {
			paddingLeft: 0,
			textAlign: 'center'
		}
	},

	columnPromoFormSubmit: {
		paddingLeft: 20,
		paddingRight: 20,
		letterSpacing: 0,
		'&:disabled': {
			backgroundColor: '#F4F4F4',
			color: 'rgba(34, 49, 62, 0.6)'
		}
	}
});

@withStyles(styles)
class PromoForm extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			alternateCoupon: null,
			redirectToCloudSubscriptions: null,
			alternateRoute: null,
			productsString: null,
			promoFormError: false
		};

		this.changePromoCode = this.changePromoCode.bind(this);
		this.clearPromoCode = this.clearPromoCode.bind(this);
		this.sendCurrentOffer = this.sendCurrentOffer.bind(this);
	}

	componentDidMount() {
		this.handleCouponApplied(this.props);	
	}	

	componentDidUpdate(prevProps, prevState) {
		if (this.props.discount.couponCodeFetchSuccess !== prevProps.discount.couponCodeFetchSuccess ||
			this.props.nrOfQualifyingProductsForCoupon !== prevProps.nrOfQualifyingProductsForCoupon ||
			this.props.nrOfQualifyingProductsForCouponInAllCurrencies !== 
				prevProps.nrOfQualifyingProductsForCouponInAllCurrencies ||
			this.props.nrOfQualifyingSubscriptions !== prevProps.nrOfQualifyingSubscriptions ||
			this.props.nrOfQualifyingPerpetualProducts !== prevProps.nrOfQualifyingPerpetualProducts ||
			this.props.type !== prevProps.type ||
			this.props.discount.isDiscountApplied !== prevProps.discount.isDiscountApplied) {
			this.handleCouponApplied(this.props);	
		}
	}

	handleCouponApplied(nextProps) {
		const { discountType, isDiscountApplied, couponSetKey, couponConfig } = nextProps.discount;
		let alternateCoupon;
		let redirectToCloudSubscriptions;
		let alternateRoute;
		let productsString;

		if (nextProps.discount.couponCodeFetchSuccess === true ||
			// No fetch is done for UPGRADE_POPUP;
			// for DISCOUNT_TYPE.MAGIX we don't show PromoForm so we don't check for this case;
			// clear expired coupon error message after user applies magix discount for perpetual products
			(isDiscountApplied && 
				(discountType === DISCOUNT_TYPE.COUPON_SET_ID 
					&& couponSetKey === DISCOUNT_KEY.UPGRADE_POPUP
				||
				// Clear coupon error field when user enters email/serial for perpetual or desktop+ product
				discountType === DISCOUNT_TYPE.MAGIX))
		) {

			if ((isDiscountApplied && 
				nextProps.nrOfQualifyingProductsForCoupon === 0 && 

				// P9052-25481 Exclude temporary redux-state value when users goes from My products and Plans to Purchase options,
				// and client still didn't update appliedProdTypeOfLastValidCombination to MAXIC_DISCOUNT_PROD_TYPE.SUBSCRIPTION
				!(this.props.type === COUPON_TYPE.SEATS &&
					nextProps.appliedProdTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL) &&

				// Exclude temporary redux-state value when users goes from perpetual to subscription,
				// in handleUpdateLastPageVisited.changeCouponType and client still didn't update coupon type to COUPON_TYPE.SEATS
				!(this.props.type === COUPON_TYPE.LICENSES && nextProps.nrOfQualifyingPerpetualProducts)
			) ||
				
				(discountType === DISCOUNT_TYPE.COUPON_ID &&
					nextProps.nrOfQualifyingProductsForCoupon === 0 &&
					nextProps.nrOfQualifyingPerpetualProducts &&
					!nextProps.isPerpetualCheckbox) ||

				(discountType === DISCOUNT_TYPE.COUPON_ID &&
					nextProps.nrOfQualifyingProductsForCoupon === 0 &&
					nextProps.nrOfQualifyingSubscriptions)
			) {
				let errorMessageKey;
				let errorMessage;
				let logError = true;
				let sendCurrentOffer = false;

				if (this.props.plan &&
					nextProps.nrOfQualifyingProductsForCoupon === 0 &&
					nextProps.nrOfQualifyingSubscriptions === 0) {
					// User enters coupon that can be used only for Designer Perpetual to 'Buy more lincenses' popup for PGD v20

					if (nextProps.nrOfQualifyingProductsForCouponInAllCurrencies) {
						errorMessageKey = 'applicable-to-this-product-in-different-currency';

						const firstPerpetualAddon = _.get(couponConfig, 'addon_ids[0]');
						const currency_code = firstPerpetualAddon.split('-')[2].toUpperCase();
						errorMessage = `${localize(invalidReason[errorMessageKey])} ${currency_code}`;						
					} else {
						errorMessageKey = 'not-applicable-to-this-product';
						errorMessage = localize(invalidReason[errorMessageKey]);
						sendCurrentOffer = true;
					}

				} else if (nextProps.nrOfQualifyingSubscriptions && this.props.type === COUPON_TYPE.LICENSES || 
					nextProps.nrOfQualifyingPerpetualProducts && this.props.type === COUPON_TYPE.SEATS) {
					errorMessageKey = 'applicable-to-products-in-different-route';

					let applicableProducts = this.props.type === COUPON_TYPE.SEATS
						?
						this.props.getQualifyingProductsForCoupon(true, false, true)
						:
						this.props.getQualifyingProductsForCoupon(true, true, false);

					applicableProducts = applicableProducts.map(planId => 
						stripHTML(this.props.addVersionToTitle(planId, PACKAGES_CONFIG[planId].title)));

					productsString = applicableProducts.join(', ');

					const pos = productsString.lastIndexOf(',');
					if (pos != -1) {
						productsString = productsString.substring(0, pos) + ' ' 
							+ localize('and') 
							+ ' '
							+ productsString.substring(pos + 1);
					}

					const fallbackCoupon = this.props.type === COUPON_TYPE.SEATS
						?
						FALLBACK_COUPON.SUBSCRIPTION
						:
						FALLBACK_COUPON.PERPETUAL;

					errorMessage = localize(invalidReason[errorMessageKey], [productsString, fallbackCoupon]);

					alternateCoupon = fallbackCoupon;

					if (this.props.plan) {
						redirectToCloudSubscriptions = true;
					} else {
						alternateRoute = this.props.type === COUPON_TYPE.SEATS ? SUBSCRIPTION_PERPETUAL_OVERVIEW : SUBSCRIPTION;
					}

				} else if (nextProps.nrOfQualifyingProductsForCouponInAllCurrencies) {
					errorMessageKey = 'applicable-to-products-in-different-currency';
					const firstPerpetualAddon = _.get(couponConfig, 'addon_ids[0]');
					const currency_code = firstPerpetualAddon.split('-')[2].toUpperCase();
					errorMessage = `${localize(invalidReason[errorMessageKey])} ${currency_code}`;

				} else if (discountType !== DISCOUNT_TYPE.MAGIX) {
					errorMessageKey = 'not-applicable-to-any-of-products';
					errorMessage = localize(invalidReason[errorMessageKey]);
					sendCurrentOffer = true;

				} else if (discountType === DISCOUNT_TYPE.MAGIX) {
					// for maxic discount clear existing coupon error field
					logError = false;
				}

				if (logError) {
					const nError = new AppError({
						message: `Coupon error after successful fetch (${errorMessageKey})`,
						details: {
							plan: this.props.plan,
							couponId: this.getPromoCode(),
							alternateCouponOffered: alternateCoupon,
							applicableProducts: productsString,
						},
						errorId: ERROR.UNKNOWN,
						visualisers: { feature: 'COUPON' }
					});				
					log.send(nError);
				}

				this.setState(prevState => ({
					...prevState,
					redirectToCloudSubscriptions,
					alternateCoupon,
					alternateRoute,
					productsString,
					promoFormError: errorMessage
				}));			

				if (this.props.plan) {
					this.props.hasCouponError(true);
				}

				sendCurrentOffer && this.sendCurrentOffer();
	
			} else {
				this.setState({
					redirectToCloudSubscriptions,
					alternateCoupon,
					alternateRoute,
					productsString,
					promoFormError: false
				});		
			
				if (this.props.plan) {
					this.props.hasCouponError(false);
				}				
			}

		} else if (nextProps.discount.couponCodeFetchSuccess === false) {
			const errorMessageKey = nextProps.discount.couponCodeInvalidReason ||
				(nextProps.discount.couponCodeFetchErrorId && errors[nextProps.discount.couponCodeFetchErrorId]) ||
				'subscriptions-error-unknown';

			const errorMessage = (nextProps.discount.couponCodeInvalidReason &&
				invalidReason[nextProps.discount.couponCodeInvalidReason] &&
				localize(invalidReason[nextProps.discount.couponCodeInvalidReason])) ||
				(nextProps.discount.couponCodeFetchErrorId &&
					errors[nextProps.discount.couponCodeFetchErrorId] &&
					localize(errors[nextProps.discount.couponCodeFetchErrorId])) ||
				localize('subscriptions-error-unknown');

			const nError = new AppError({
				message: `Coupon error after failed fetch (${errorMessageKey})`,
				errorId: ERROR.UNKNOWN,
				details: {
					couponCodeInvalidReason: nextProps.discount.couponCodeInvalidReason,
					couponCodeFetchErrorId: nextProps.discount.couponCodeFetchErrorId,
					couponId: this.getPromoCode()
				},
				visualisers: { feature: 'COUPON' }
			});				
			log.send(nError);

			this.setState(prevState => ({
				...prevState,
				redirectToCloudSubscriptions,
				alternateCoupon,
				alternateRoute,
				productsString,
				promoFormError: errorMessage
			}));

			if ([
				'not-applicable-to-any-of-products',
				'not-applicable-to-this-product',
				errors[ERROR.INVALID_COUPON_CODE_ID],
				errors[ERROR.COUPON_CODE_DOES_NOT_EXIST],
				'does-not-exist',
				'serial-number',
				'expired'].includes(errorMessageKey)) {
				this.sendCurrentOffer();
			}
		}		
	}

	sendCurrentOffer() {
		const payload = {
			productType: this.props.type === COUPON_TYPE.SEATS ? 'subscription' : 'perpetual',
			lang: i18n.getCurrentLanguage(),
			coupon: this.getPromoCode(),
			email: _.get(this.props.user, 'mainEmail'),
			type: this.props.isPerpetualCheckbox ||
				this.props.type === COUPON_TYPE.LICENSES ||
				this.props.category === PLAN_CATEGORIES.CREATIVE_TOOLS
				?
				'desktop' : 'cloud'
		};
		sendCurrentOfferToUser(payload);
	}

	onPromoCodeApply(value) {
		// When coupon on Desktop > One-time purchase is submited, request is made to subscriptionEstimation endpoint
		// as in this case returned couponConfig will be used for both subscriptions and perpetual addons
		if (this.props.type === COUPON_TYPE.LICENSES && !this.props.isPerpetualCheckbox) {
			// here we first fetch and validate coupon (check expired date, if coupon exists etc),
			// then if it's valid we apply it to perpetual producs
			this.props.applyDiscountUsingCouponId(value || this.props.discount.userSuppliedPromoCode, COUPON_TYPE.LICENSES, true);
		} else {
			// "without validation" means we don't do initial fetching and validation before using coupon
			// (ie when sending to estimation endpoint)
			this.props.applyDiscountUsingCouponIdWithoutValidation(
				value || this.props.discount.userSuppliedPromoCode,
				COUPON_TYPE.SEATS,
				true,
				DISCOUNT_TYPE.COUPON_ID);
		}

		trackApplyCouponClicked(value || this.props.discount.userSuppliedPromoCode, getTrackingOptions(this.props.company));
	}

	clearPromoCode() {
		this.props.clearAppliedDiscount();
		this.setState({ promoFormError: false });
		if (this.props.plan) {
			this.props.hasCouponError(false);
		}				
	}

	changePromoCode(value) {
		this.props.setUserSuppliedPromoCode(value);
		this.onPromoCodeApply(value);
	}

	onPromoCodeChange(event) {
		this.props.setUserSuppliedPromoCode(event.target.value);
		// delete discount when user backspaces and deletes coupon code
		this.props.discount.isDiscountApplied && !event.target.value && this.props.clearAppliedDiscount();
	}

	onPromoCodeKeyPress(event) {
		if (!this.isPromoFormSubmitEnabled()) return;
		if (event.key === 'Enter') {
			this.onPromoCodeApply();
		}		
	}

	isPromoFormSubmitEnabled() {
		const { discountType, userSuppliedPromoCode } = this.props.discount;

		// allow entering coupon when magix discount is applied,
		// otherwise in case of DISCOUNT_TYPE.COUPON_ID and discountType === DISCOUNT_TYPE.COUPON_SET_ID
		// user has first to clear existing coupon

		return (!this.props.discount.isDiscountApplied || discountType === DISCOUNT_TYPE.MAGIX) &&
		(!this.state.promoFormError ||
			this.state.promoFormError === localize(errors[ERROR.OFFLINE]) ||
			this.state.promoFormError === localize(errors[ERROR.API_REQUEST_LIMIT_EXCEEDED])) &&
		userSuppliedPromoCode && userSuppliedPromoCode.replace(/[\r\n\t\s]/g, '').length > 0;
	}

	getPromoCode() {
		const { discountType, couponId, couponSetKey, userSuppliedPromoCode, failedCouponId } = this.props.discount;
		let promoCodeValue = '';
		if (userSuppliedPromoCode) {
			promoCodeValue = userSuppliedPromoCode;
		} else if (couponSetKey && discountType === DISCOUNT_TYPE.COUPON_SET_ID) {
			promoCodeValue = DISCOUNTS_CONFIG[couponSetKey].coupon_set_id;
		} else if (couponId || failedCouponId) {
			promoCodeValue = couponId || failedCouponId;
		}

		return promoCodeValue;
	}

	renderActiveOfferLink() {
		const { classes } = this.props;

		if (this.props.plan || this.props.type === COUPON_TYPE.LICENSES) {
			const { couponConfig } = this.props.discount;

			let addonList;

			if (this.props.isPerpetualCheckbox) {
				addonList = [
					SUBSCRIPTION_PLAN.PHOTO_PERPETUAL,
					SUBSCRIPTION_PLAN.WEB_PERPETUAL,
					SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL];
			} else if (this.props.plan) {
				addonList = [this.props.plan];
			} else {
				addonList = _.get(couponConfig, 'addon_ids');
				// case when expired cloud coupon is entered
				if (!addonList) {
					addonList = [
						SUBSCRIPTION_PLAN.PHOTO_PERPETUAL,
						SUBSCRIPTION_PLAN.WEB_PERPETUAL,
						SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL];
				}
			}

			if (!_.isEmpty(addonList)) {

				let applicableProducts = [];
				addonList.forEach(addon => {
					const singleAddonId = addon.split('_')[0].toLowerCase();
					if ([
						SUBSCRIPTION_PLAN.PHOTO_PERPETUAL,
						SUBSCRIPTION_PLAN.WEB_PERPETUAL,
						SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL].includes(singleAddonId)) {
						applicableProducts.push(singleAddonId);
					}
				});

				applicableProducts = _.uniq(applicableProducts);

				applicableProducts = applicableProducts.map((planId, index) => {
					return (
						<React.Fragment key={`active-offer-link-${index}`}>
							{applicableProducts.length > 1 && index === applicableProducts.length - 1 && (` ${localize('and')} `)}
							{applicableProducts.length > 1 && index > 0 && index < applicableProducts.length - 1 && ', '}
							<Link
								component="button"
								variant="body2"
								data-tid='active-offer-url'
								className={classes.activeOfferLink}
								underline='always'
								onClick={() => {
									let url;
									trackActiveOfferLinkClicked(getTrackingOptions(this.props.company));
									if (planId === SUBSCRIPTION_PLAN.PHOTO_PERPETUAL) {
										url = PHOTOL_ACTIVE_OFFERS_URL;
									} else if (planId === SUBSCRIPTION_PLAN.WEB_PERPETUAL) {
										url = WEBL_ACTIVE_OFFERS_URL;
									} else if (planId === SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL) {
										url = DESIGNERL_ACTIVE_OFFERS_URL;
									}

									if (i18n.getCurrentLanguage(false) === 'de') {
										url = url.replace('xara.com', 'xara.com/de');
									}

									window.open(url, '_blank');
								}}
							>
								{stripHTML(this.props.addVersionToTitle(planId, PACKAGES_CONFIG[planId].title))}
							</Link>					
						</React.Fragment>
					);
				});
	
				if (!_.isEmpty(applicableProducts)) {
					return (
						<React.Fragment>
							<div className={classes.activeOfferMessage}>
								{localize('subscription-active-offers-perpetual')} &nbsp;{applicableProducts}
							</div>
						</React.Fragment>
					);
				}
			}
		} else {
			return (
				<Link
					component="button"
					variant="body2"
					data-tid='active-offer-url'
					className={classNames(classes.activeOfferLink, classes.activeOfferMessage)}
					underline='always'
					onClick={() => {
						trackActiveOfferLinkClicked(getTrackingOptions(this.props.company));

						let url = SUBSCRIPTION_ACTIVE_OFFERS_URL;
						if (i18n.getCurrentLanguage(false) === 'de') {
							url = url.replace('xara.com', 'xara.com/de');
						}

						window.open(url, '_blank');
					}}
				>
					{localize('subscription-active-offers-cloud')}
				</Link>
			);
		} 
	}

	render() {
		const { classes } = this.props;
		const { isDiscountApplied, discountType, couponId, userSuppliedPromoCode } = this.props.discount;
		const errorClasses = { root: classes.columnPromoFormInputRoot, error: classes.error };

		const promoCodeValue = this.getPromoCode();

		let buttonLabel;
		if (isDiscountApplied && (discountType === DISCOUNT_TYPE.COUPON_ID || discountType === DISCOUNT_TYPE.COUPON_SET_ID)) {
			if (discountType === DISCOUNT_TYPE.COUPON_ID) {
				if (userSuppliedPromoCode) {
					buttonLabel = userSuppliedPromoCode !== couponId
						?
						localize('subscription-promo-section-apply')
						:
						localize('subscription-promo-section-applied');
				} else if (couponId) {
					buttonLabel = localize('subscription-promo-section-applied');
				}
			} else if (discountType === DISCOUNT_TYPE.COUPON_SET_ID) {
				buttonLabel = localize('subscription-promo-section-applied');
			}
		} else {
			buttonLabel = localize('subscription-promo-section-apply');
		}


		const hasAppliedData = isDiscountApplied &&
			(discountType === DISCOUNT_TYPE.COUPON_ID || discountType === DISCOUNT_TYPE.COUPON_SET_ID) || 
		
			this.state.promoFormError &&
			this.state.promoFormError !== localize(errors[ERROR.OFFLINE]) &&
			this.state.promoFormError !== localize(errors[ERROR.API_REQUEST_LIMIT_EXCEEDED]);
		
		const renderErrorMessage = () => {
			if (this.state.alternateCoupon || this.state.redirectToCloudSubscriptions) {
				return (
					<span className={classes.fallbackCouponMessage}>
						{localize('subscriptions-error-coupon-does-not-qualify-fallback-1', this.state.productsString)}

						<Link
							component="button"
							variant="body2"
							data-tid='apply-coupon-link'
							className={classes.fallbackCouponMessageLink}
							underline='always'
							onClick={() => {
								if (this.state.redirectToCloudSubscriptions) {
									this.props.handleSwitchToPlansFromBuyMoreLicensesPopup();
								} else {
									this.props.changeRoute({
										pathname: getRoute(
											this.state.alternateRoute.replace(':currency?', this.props.currency.key),
											this.props.company.id
										),
										state: {
											// todo - resolve category based on coupon config
											preselectCategory: PLAN_CATEGORIES.CREATIVE_TOOLS,
											isCouponMissmatchRedirect: true
										}
									});
								}
							}}
						>
							({localize('subscriptions-error-coupon-does-not-qualify-view-products')})
						</Link>.&nbsp;

						{localize('subscriptions-error-coupon-does-not-qualify-fallback-2', this.state.alternateCoupon)}

						<Link
							component="button"
							variant="body2"
							data-tid='apply-coupon-link'
							className={classes.fallbackCouponMessageLink}
							underline='always'
							onClick={() => {
								this.changePromoCode(this.state.alternateCoupon);
							}}
						>
							({localize('subscription-promo-section-apply-coupon')}).
						</Link>
					</span>
				);
			} else {
				return (
					<React.Fragment>
						{this.state.promoFormError}&nbsp;
						{this.state.promoFormError === localize(invalidReason['expired']) && this.renderActiveOfferLink()}
						{
							this.state.promoFormError !== localize(errors[ERROR.OFFLINE]) &&
							this.state.promoFormError !== localize(errors[ERROR.API_REQUEST_LIMIT_EXCEEDED]) && (
								<Link
									component="button"
									variant="body2"
									data-tid='have-questions-link'
									className={classes.errorMessageLink}
									underline='always'
									onClick={() => this.props.contactUsHandler(
									localize('subscription-contact-support-message',
									[promoCodeValue, this.state.promoFormError]
									))}
								>
									{localize('subscription-contact-support')}
								</Link>
							)
						}
					</React.Fragment>
				);
			}
		};

		return (
			<Grid
				container
				direction="row"
				className={classes.promoForm}>
				<Grid item className={classes.columnPromoFormInputColumn}>
				
					<FormField
						value={promoCodeValue}
						autoComplete='off'
						className={classNames(classes.columnPromoFormInput, classes.textInput)}
						data-tid={'input-coupon-code'}
						onChange={event => this.onPromoCodeChange(event)}
						onKeyPress={event => this.onPromoCodeKeyPress(event)}
						id={'input-coupon-code'}
						placeholder={localize('subscription-coupon-code-placeholder')}
						margin="normal"
						helperText={this.state.promoFormError && (
							<div
								variant='body2'
								className={classes.errorHelperText}
							>
								{renderErrorMessage()}
							</div>
						)}
						error={!!this.state.promoFormError}
						FormHelperTextProps={{ classes: errorClasses }}
						inputRef={this['input-coupon-code']}
						disabled={hasAppliedData}
					/>

					{hasAppliedData && (
						<Link
							component="button"
							variant="body2"
							data-tid='clear-promo-code-button'
							className={classes.clearPromoCodeButton}
							underline='none'
							onClick={() => this.clearPromoCode()}
						>
							<ClearIcon />
						</Link>
					)}

				</Grid>
				<Grid item className={classes.columnPromoFormSubmitColumn}>
					<Button
						variant='contained'
						data-tid="button-apply-coupon"
						color='primary'
						onClick={() => this.onPromoCodeApply()}
						className={classNames(classes.columnPromoFormSubmit, classes.button)}
						disabled={!this.isPromoFormSubmitEnabled()}
					>
						{buttonLabel}
					</Button>
				</Grid>								
			</Grid>
		);
	}
}

PromoForm.propTypes = {
	company: PropTypes.object,
	classes: PropTypes.object,
	discount: PropTypes.object.isRequired,
	contactUsHandler: PropTypes.func.isRequired,
	setUserSuppliedPromoCode: PropTypes.func,
	clearAppliedDiscount: PropTypes.func,
	setSubscriptionPeriod: PropTypes.func,
	applyDiscountUsingCouponIdWithoutValidation: PropTypes.func,
	applyDiscountUsingCouponId: PropTypes.func,
	nrOfQualifyingProductsForCoupon: PropTypes.number,
	nrOfQualifyingProductsForCouponInAllCurrencies: PropTypes.number,
	nrOfQualifyingSubscriptions: PropTypes.number,
	nrOfQualifyingPerpetualProducts: PropTypes.number,
	type: PropTypes.string,
	isPerpetualCheckbox: PropTypes.bool,
	getQualifyingProductsForCoupon: PropTypes.func,
	addVersionToTitle: PropTypes.func,
	plan: PropTypes.string,
	changeRoute: PropTypes.func,
	handleSwitchToPlansFromBuyMoreLicensesPopup: PropTypes.func,
	currency: PropTypes.object,
	hasCouponError: PropTypes.func,
	appliedProdTypeOfLastValidCombination: PropTypes.string,
	user: PropTypes.object.isRequired,
	category: PropTypes.string
};

const mapStateToProps = state => ({
	company: state.companies.rawDataById[state.companies.selectedId],
	crs: state.crs,
	discount: state.discount,
	app: state.app,
	user: state.session.user,
	selectedCompanyId: state.companies.selectedId,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	setUserSuppliedPromoCode,
	clearAppliedDiscount,
	setSubscriptionPeriod,
	applyDiscountUsingCouponId,
	applyDiscountUsingCouponIdWithoutValidation
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PromoForm);


// WEBPACK FOOTER //
// ./src/components/PromoForm/index.js